export default __webpack_public_path__ + "static/media/Search-dark.c2acf86d.svg";